import classNames from 'classnames'
import * as grid from '@campgladiator/cgui-core.styles.helpers.grid'
import { authSelector } from '../../redux/features/Auth'
import { useAppSelector } from '../../redux/store'
import { LoginHeader } from './components/LoginHeader'
import { LoginPanel } from './components/LoginPanel'
import { LoginSignUpPanel } from './components/LoginSignUpPanel'
import { LoginFooter } from './components/LoginFooter'
import styles from './Login.module.scss'

const Login = () => {
  const { isLoading, error } = useAppSelector(authSelector)

  return (
    <div className={styles.content}>
      <div className={classNames(grid.container)}>
        <div className={classNames(grid.row, styles.row)}>
          <div
            className={classNames(
              grid.col12,
              grid.colMd8,
              grid.colLg6,
              grid.colXl5,
            )}
          >
            <div className={styles.loginForm}>
              <LoginHeader />
              <LoginPanel isLoginPending={isLoading} authError={error} />
              <LoginSignUpPanel />
              <LoginFooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
